import ckeditorService from '../../../../../services/CKEditorService';

const extendedTextCkeditorSelector = {
    selectProps(state) {
        const { drawing, settings } = state;

        return {
            hasInProgressDrawings: drawing.inProgressDrawings?.length > 0,
            inProgressDrawings: drawing.inProgressDrawings,
            settings,
            shouldForbidCopyPasteButtons: ckeditorService.shouldForbidCopyPasteButtons(),
        };
    },
};

export default extendedTextCkeditorSelector;
